export function isArrayOfEmptyStrings(arr: string[]) {
  if (!arr) arr = [''];
  return arr.every((str) => str === '');
}
export function isInvalidArray(arr: any[]) {
  if (!arr) arr = [''];
  return arr.every((str) => [undefined, null, ''].includes(str));
}
